import React from "react";
import TeamPageSection from "../sections/TeamPageSection/Content";
const TeamPage = () => {
  return <TeamPageSection />;
};

export default TeamPage;
